// The date block Coming up and Free webinars draw (Main.dc.html, PhoneLibrary.dc.html): the day of the
// week, the date and the month. Spans (display: flex in library.css), so it can sit inside a thumbnail
// frame or a link, which are inline, as valid markup.
export function DateBlock({ block, small }) {
  return (
    <span className={small ? 'dblock dblock--small' : 'dblock'}>
      <span className="dblock-edge">{block.dow}</span>
      <span className="dblock-day">{block.day}</span>
      <span className="dblock-edge">{block.mon}</span>
    </span>
  )
}
